/**
 * Sent when a window is opened by the Electron Desktop Agent,
 * via preload.ts.  Could be a desktop agent window, an iframe or an app window.
 */
export const ELECTRON_HELLO = 'electron-hello';
/**
 * Sent when the Desktop Agent web page connects to the server.
 */
export const DA_HELLO = 'da-hello';
/**
 * Sent from the Desktop Agent to the server to say that the client has updated state
 */
export const SAIL_CLIENT_STATE = 'sail-client-state';
/**
 * Sent when an App connects to the server
 */
export const APP_HELLO = 'app-hello';
/**
 * Sent by the browser desktop agent to the server to say that an app is being launched,
 * please return an instance ID.
 */
export const DA_REGISTER_APP_LAUNCH = 'da-launch';
/**
 * Sent by the browser desktop agent to the server to request a directory listing.
 */
export const DA_DIRECTORY_LISTING = 'da-directory-listing';
/**
 * Sent by the server to the browser desktop agent after the app has completed the FDC3 handshake.  This is a request
 * to know which channel the app should be placed in.
 */
export const SAIL_CHANNEL_SETUP = 'sail-channel-setup';
/**
 * A request from the da server to the da client asking it to pop up the intent resolver
 * and figure out what intent the user wants.
 */
export const SAIL_INTENT_RESOLVE = 'sail-intent-resolve';
/**
 * A request by the server to the desktop agent client to open a new panel/tab for an app to go in,
 * and start the load process.
 */
export const SAIL_APP_OPEN = 'sail-app-open';
/**
 * A message from the desktop agent browser to the server to say that it wants to change the user channel of the app.
 */
export const SAIL_CHANNEL_CHANGE = 'sail-channel-change';
/**
 * A message from the server to the browser desktop agent to tell it what state the apps are in.
 */
export const SAIL_APP_STATE = 'sail-app-state';
/**
 * These two messages carry FDC3 Communication Protocol messages.
 */
export const FDC3_APP_EVENT = 'fdc3-app-event'; // from the app to the server
export const FDC3_DA_EVENT = 'fdc3-da-event'; // from the server to the app
/**
 * From the channel selector and intent resolver  UIs to the server to tell it that it
 * needs to be kept up to date with the user channel details.
 */
export const CHANNEL_RECEIVER_HELLO = 'channel-receiver-hello';
/**
 * From the server to the channel selector/intent resolver to tell it that the channels
 * have changed.
 */
export const CHANNEL_RECEIVER_UPDATE = 'channel-receiver-update';
/**
 * Sent by the intent resolver to the server to tell it that the user wants to open an app in a specific channel.
 */
export const SAIL_INTENT_RESOLVE_ON_CHANNEL = 'sail-intent-resolve-open-channel';
/**
 * Sent from the server to the browser desktop agent to tell it that an app has broadcast a context.
 */
export const SAIL_BROADCAST_CONTEXT = 'sail-broadcast-context';
//# sourceMappingURL=message-types.js.map